import { getAccHostname } from '@adsk/acs-sc-web-platform-api';

export const getMFABlockPageUrl = ({
  accountId,
  projectId,
  redirectUrl,
} = {}) => {
  if (!accountId) {
    return `/page-not-found`;
  }
  let baseUrl = `${getAccHostname()}/access/mfa/accounts/${accountId}`;
  if (projectId) {
    baseUrl += `/projects/${projectId}`;
  }
  if (redirectUrl) {
    return `${baseUrl}?redirectUrl=${encodeURIComponent(redirectUrl)}`;
  }
  return baseUrl;
};
